import React, { useState } from "react";
import "../styles/FAQ.css";

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    { question: "How long are the courses?", answer: "The learning paths run from 3 to 6 months depending on the track and project depth." },
    { question: "Do I get hands-on projects?", answer: "Yes. Each course includes practical projects so learners can build a portfolio while learning." },
    { question: "Is the YouTube content free?", answer: "Yes. Demo videos and selected tutorials are available on the YouTube channel." },
    { question: "Who can join?", answer: "Both beginners and working professionals can join, with guided learning paths for each level." },
    { question: "Do I need prior IT experience?", answer: "No. Our beginner-friendly programs are designed for students, fresh graduates, and professionals from any background." },
    { question: "Will I receive a certificate after completion?", answer: "Yes. Learners receive a course completion certificate after successfully completing the training and projects." },
    { question: "Are live classes available?", answer: "Yes. We conduct live interactive sessions where learners can ask questions and get guidance directly from industry engineers." },
    { question: "Do you provide placement assistance?", answer: "Yes. We provide resume building, interview preparation, mock interviews, and career guidance to help learners prepare for job opportunities." },
    { question: "Can I access recorded sessions?", answer: "Yes. Recorded sessions are provided so you can revisit lessons anytime and learn at your own pace." },
    { question: "What technologies will I learn?", answer: "Depending on the course, you may learn AWS, Azure, DevOps tools, Linux, Docker, Kubernetes, Terraform, Git, CI/CD, and Full Stack Development technologies." },
    { question: "How are projects evaluated?", answer: "Projects are reviewed by experienced engineers who provide feedback and guidance to help improve your practical skills." },
    { question: "Can working professionals join the training?", answer: "Absolutely. Our flexible schedules and recorded sessions make it easy for working professionals to learn alongside their jobs." },
  ];

  return (
    <section id="faq" className="section">
      <h2>Frequently Asked Questions</h2>

      <div className="faq-grid">
        {faqs.map((item, index) => (
          <div className="faq-card" key={item.question}>
            <button
              type="button"
              className="faq-question"
              onClick={() => setActiveIndex(activeIndex === index ? null : index)}
            >
              {item.question}
              <span className={`faq-icon ${activeIndex === index ? "rotate" : ""}`}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 9L12 15L18 9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </button>

            {activeIndex === index && (
              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
